
import { AppConfig } from 'src/config/app-config.service';
import { IMapper } from 'src/core/sharepoint/model/mapper';
import { Language } from 'src/core/utility/enums/enums';
import { Bid } from './bid';
import { bidConstants } from './bid-const';


export class BidMapper implements IMapper {
    appSettings=  AppConfig.settings;;

    convertListItems(items: SP.ListItemCollection<any>): Bid[] {

        let bidItems: Array<Bid> = new Array<Bid>();
        if (items != null) {
            let listItemsEnumerator = items.getEnumerator();

            while (listItemsEnumerator.moveNext()) {

                bidItems.push(this.convertItem(listItemsEnumerator.get_current()));
            }
        }
        return bidItems;
    }

    convertItem(item: SP.ListItem<any>,includeAttachments:boolean=true): Bid {
        let bid: Bid = null;
        if (item != null) {
            bid = new Bid();

            bid.title = item.get_item(bidConstants.list.fields.title);
            bid.brief = item.get_item(bidConstants.list.fields.brief);
            bid.description = item.get_item(bidConstants.list.fields.description);
            bid.expirationDate = item.get_item(bidConstants.list.fields.expirationDate);
            bid.modificationDate = item.get_item(bidConstants.list.fields.modificationDate);
            bid.url= bidConstants.slash + Language[_spPageContextInfo.currentLanguage] + this.appSettings.bidDetailsPageUrl +"?id="+item.get_item(bidConstants.list.fields.id);

            if (includeAttachments && item.get_item('Attachments')) {
                var attEnumerator = item.get_attachmentFiles().getEnumerator();
                while (attEnumerator.moveNext()) {
                    var attachment = attEnumerator.get_current();
                    bid.fileName = attachment.get_fileName();
                    bid.file = attachment.get_serverRelativeUrl();
                    
                }
            }
        
        }
        return bid;
    }
    
    convertListItemsPaging(data: any): any {

        let result:any = {};
        result.Items = new Array<Bid>();
        if (data.items != null) {
            let listItemsEnumerator = data.items.getEnumerator();

            while (listItemsEnumerator.moveNext()) {

                result.Items.push(this.convertItem(listItemsEnumerator.get_current(),false));
            }
        }
        result.hasNext = data.hasNext;
        return result;
    }
    
    
    GetData(item: any): string {
        if (item != null) {
            var arr: string[] = new Array();
            for (let index = 0; index < item.length; index++) {

                arr.push(item[index].get_lookupValue());
            }
            return arr.join(',')
        }
        return "";
    }
}
